export const INITIATE_GOOGLE_ANALYTICS = 'INITIATE_GOOGLE_ANALYTICS'
export const GA_SEND_PAGE_VIEW = 'GA_SEND_PAGE_VIEW'
export const GA_SEND_CLICK_EVENT = 'GA_SEND_CLICK_EVENT'
export const GA_SEND_USER_INPUT = 'GA_SEND_USER_INPUT'
